import api from './api';


export const certificateService = {
 
  getCertificates: async () => {
    const response = await api.get('/certificates');
    return response.data;
  },

  
  getCertificateByCourse: async (courseId) => {
    const response = await api.get(`/certificates/course/${courseId}`);
    return response.data;
  },

  generateCertificate: async (courseId) => {
    const response = await api.post(`/certificates/course/${courseId}/generate`);
    return response.data;
  },

  downloadCertificate: async (certificateId) => {
    try {
      
      const response = await api.get(`/certificates/${certificateId}/download`, {
        responseType: 'blob',
        timeout: 120000, // 2 minutes timeout for PDF generation
      });
      
      
      const contentType = response.headers['content-type'] || 'application/pdf';
      
      if (!contentType.includes('pdf')) {
        console.error('[Certificate Service] Unexpected content type:', contentType);
        throw new Error(`Server returned unexpected content type: ${contentType}. Expected PDF.`);
      }
      
      const blob = new Blob([response.data], { type: 'application/pdf' });
      
      if (blob.size < 1000) {
        console.error('[Certificate Service] PDF too small, likely invalid. Size:', blob.size);
        throw new Error('Downloaded PDF appears to be invalid (too small)');
      }
      
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      
      const contentDisposition = response.headers['content-disposition'];
      let filename = `certificate-${certificateId}.pdf`; // Default to PDF
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }
      
      if (!filename.toLowerCase().endsWith('.pdf')) {
        filename = filename.replace(/\.(docx|doc)$/i, '') + '.pdf';
      }
      
      
      link.href = url;
      link.download = filename;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error('[Certificate Service] Error downloading certificate:', error);
      if (error.response) {
        console.error('[Certificate Service] Error response:', {
          status: error.response.status,
          statusText: error.response.statusText,
          headers: error.response.headers,
        });
      }
      throw error;
    }
  },
};

